/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NutritionAndDietUpsertRequestDto
 */
export interface NutritionAndDietUpsertRequestDto {
    /**
     * Identity of the Nutrition and Diet
     * @type {string}
     * @memberof NutritionAndDietUpsertRequestDto
     */
    id: string;
    /**
     * Diet type
     * @type {string}
     * @memberof NutritionAndDietUpsertRequestDto
     */
    dietType: string;
    /**
     * Breakfast
     * @type {string}
     * @memberof NutritionAndDietUpsertRequestDto
     */
    breakfast: string;
    /**
     * Lunch
     * @type {string}
     * @memberof NutritionAndDietUpsertRequestDto
     */
    lunch: string;
    /**
     * Dinner
     * @type {string}
     * @memberof NutritionAndDietUpsertRequestDto
     */
    dinner: string;
    /**
     * Snacks or beverages
     * @type {string}
     * @memberof NutritionAndDietUpsertRequestDto
     */
    snacksOrBeverages: string;
    /**
     * Water amount(number) per day
     * @type {string}
     * @memberof NutritionAndDietUpsertRequestDto
     */
    waterPerDay: string;
    /**
     * Food insensitivities
     * @type {string}
     * @memberof NutritionAndDietUpsertRequestDto
     */
    foodInsensitivities: string;
    /**
     * Other diet type
     * @type {string}
     * @memberof NutritionAndDietUpsertRequestDto
     */
    otherDietType?: string;
    /**
     * Daily meals
     * @type {string}
     * @memberof NutritionAndDietUpsertRequestDto
     */
    dailyMeals?: string;
    /**
     * Sources of hydration
     * @type {string}
     * @memberof NutritionAndDietUpsertRequestDto
     */
    hydrationSources?: string;
    /**
     * Additional information
     * @type {string}
     * @memberof NutritionAndDietUpsertRequestDto
     */
    additionalInformation: string;
    /**
     * Indicates if this update is part of onboarding flow
     * @type {boolean}
     * @memberof NutritionAndDietUpsertRequestDto
     */
    isOnboarding?: boolean;
}

/**
 * Check if a given object implements the NutritionAndDietUpsertRequestDto interface.
 */
export function instanceOfNutritionAndDietUpsertRequestDto(value: object): value is NutritionAndDietUpsertRequestDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('dietType' in value) || value['dietType'] === undefined) return false;
    if (!('breakfast' in value) || value['breakfast'] === undefined) return false;
    if (!('lunch' in value) || value['lunch'] === undefined) return false;
    if (!('dinner' in value) || value['dinner'] === undefined) return false;
    if (!('snacksOrBeverages' in value) || value['snacksOrBeverages'] === undefined) return false;
    if (!('waterPerDay' in value) || value['waterPerDay'] === undefined) return false;
    if (!('foodInsensitivities' in value) || value['foodInsensitivities'] === undefined) return false;
    if (!('additionalInformation' in value) || value['additionalInformation'] === undefined) return false;
    return true;
}

export function NutritionAndDietUpsertRequestDtoFromJSON(json: any): NutritionAndDietUpsertRequestDto {
    return NutritionAndDietUpsertRequestDtoFromJSONTyped(json, false);
}

export function NutritionAndDietUpsertRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NutritionAndDietUpsertRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dietType': json['dietType'],
        'breakfast': json['breakfast'],
        'lunch': json['lunch'],
        'dinner': json['dinner'],
        'snacksOrBeverages': json['snacksOrBeverages'],
        'waterPerDay': json['waterPerDay'],
        'foodInsensitivities': json['foodInsensitivities'],
        'otherDietType': json['otherDietType'] == null ? undefined : json['otherDietType'],
        'dailyMeals': json['dailyMeals'] == null ? undefined : json['dailyMeals'],
        'hydrationSources': json['hydrationSources'] == null ? undefined : json['hydrationSources'],
        'additionalInformation': json['additionalInformation'],
        'isOnboarding': json['isOnboarding'] == null ? undefined : json['isOnboarding'],
    };
}

export function NutritionAndDietUpsertRequestDtoToJSON(json: any): NutritionAndDietUpsertRequestDto {
    return NutritionAndDietUpsertRequestDtoToJSONTyped(json, false);
}

export function NutritionAndDietUpsertRequestDtoToJSONTyped(value?: NutritionAndDietUpsertRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'dietType': value['dietType'],
        'breakfast': value['breakfast'],
        'lunch': value['lunch'],
        'dinner': value['dinner'],
        'snacksOrBeverages': value['snacksOrBeverages'],
        'waterPerDay': value['waterPerDay'],
        'foodInsensitivities': value['foodInsensitivities'],
        'otherDietType': value['otherDietType'],
        'dailyMeals': value['dailyMeals'],
        'hydrationSources': value['hydrationSources'],
        'additionalInformation': value['additionalInformation'],
        'isOnboarding': value['isOnboarding'],
    };
}

